import { Link } from 'gatsby'
import React, { useContext } from 'react'
import styled from 'styled-components'
import { AppContext } from '../../../contexts/AppContext'

const Dropdown = styled.div`
        font-family: ${props => props.theme.default.fonts.family};
        position: absolute;
        min-width: 300px;
        background-color: ${props => props.theme.default.colors.headerMenu};
    `

const OptionList = styled.ul`
        list-style-type: none;
        margin: 0;
        padding: 0;
    `

const Option = styled.li`
        padding: 20px 40px !important;
        font-size: 10pt;
        text-transform: uppercase;
        margin-bottom: 0px !important;
        cursor: pointer;
        color: ${props => props.theme.default.colors.darkTeal};

        &:hover {
            background-color: rgba(0,0,0,0.05)
        }
    `

const MenuSection = styled.h4`
        font-size: 8pt;
        text-transform: uppercase;
        padding: 20px 40px 0 40px;
        margin: 0;
    `

const MenuSectionText = styled.p`
        font-size: 8pt;
        padding-right: 40px;
        max-width: 250px;
        margin-left: 40px;
    `

export const HowMenu = ({ open }) => {

    const { appState, sendEvent } = useContext(AppContext);

    return (
        open && <Dropdown>
            <MenuSection>{appState.i18n.header.energyTransition}</MenuSection>
            <MenuSectionText>{appState.i18n.header.energyTransition_description}</MenuSectionText>
            <OptionList>
                <Link to="/how/circular-economy" onClick={() => sendEvent("Navigation", "Header", "Circular Economy")}>
                    <Option>{appState.i18n.header.circularEconomy}</Option>
                </Link>
                {/* <Link to="/how/advantages-vs-fossil" onClick={() => sendEvent("Navigation", "Header", "Advantages vs Fossil")}>
                    <Option>{appState.i18n.header.advantagesVsFossil}</Option>
                </Link> */}
            </OptionList>

            <MenuSection>{appState.i18n.header.tips}</MenuSection>
            <MenuSectionText>{appState.i18n.header.tips_description}</MenuSectionText>
            <OptionList>
                <Link to="/how/public-charging" onClick={() => sendEvent("Navigation", "Header", "Public Charging")}>
                    <Option>{appState.i18n.header.howPublicCharging}</Option>
                </Link>
                <Link to="/how/private-charging" onClick={() => sendEvent("Navigation", "Header", "Private Charging")}>
                    <Option>{appState.i18n.header.howPrivateCharging}</Option>
                </Link>
                {/* <Link to="/how/invoice-in-detail" onClick={() => sendEvent("Navigation", "Header", "Detailed Invoice")}>
                    <Option>{appState.i18n.header.detailedInvoice}</Option>
                </Link> */}
            </OptionList>



        </Dropdown>
    )
}
